<template>
    <van-dialog
        v-model="isShow"
        title="请您对客服的本次服务进行评价"
        show-cancel-button
        confirm-button-text="提交评价"
        :show-confirm-button="!isDisabled"
        @confirm="confirm"
        @close="close">
        <div class="dialog__content">
            <div class="star">
                <div class="star__list">
                    <div class="star__item"
                        v-for="item in starList"
                        :class="{
                            'is-active': item.star <= starNum
                        }"
                        :key="item.star"
                        @click="setStar(item.star)">
                        <i class="star__icon icon_star"></i>
                    </div>
                </div>
                <div class="star__remark">{{remark}}</div>
            </div>
            <div class="suggestion"
                v-if="starNum">
                <textarea v-model="suggestion"
                    cols="30"
                    rows="3"
                    placeholder="欢迎给我们的服务提建议~ (选填)"></textarea>
            </div>
        </div>
    </van-dialog>
</template>

<script>
    import { SHOW_EVALUATION_DIALOG } from '@/constants/pub_sub'
    import { postEvaluation } from '@/api/evaluation'

    export default {
        name: 'TheEvaluationDialog',
        data () {
            return {
                isShow: false,
                starNum: 0,
                suggestion: '',
                starList: [
                    { star: 1, remark: '非常不满意，各方面都很差' },
                    { star: 2, remark: '不满意，比较差' },
                    { star: 3, remark: '一般，还需改善' },
                    { star: 4, remark: '比较满意，仍可改善' },
                    { star: 5, remark: '非常满意，完美' }
                ],
                chatServiceId: 0
            }
        },
        computed: {
            remark () {
                const matchItem = this.findByStar(this.starNum)

                if (matchItem) {
                    return matchItem.remark
                }
                return ''
            },
            isDisabled () {
                return typeof this.findByStar(this.starNum) === 'undefined'
            }
        },
        methods: {
            findByStar (starNum) {
                return this.starList.find(item => item.star === starNum)
            },
            setStar (value) {
                this.starNum = value
            },
            async confirm () {
                try {
                    await postEvaluation(
                        this.chatServiceId,
                        this.starNum,
                        this.suggestion.trim()
                    )
                    this.$toast('提交评价成功')
                } catch (err) {
                    // eslint-disable-next-line
                    console.error(err)
                    this.isShow = true
                }
            },
            reset () {
                this.starNum = 0
                this.suggestion = ''
                this.chatServiceId = 0
            },
            close () {
                this.reset()
            }
        },
        created () {
            this.$eventBus.$on(SHOW_EVALUATION_DIALOG, ({ chat_service_id: chatServiceId }) => {
                if (!chatServiceId) {
                    return
                }
                this.chatServiceId = chatServiceId
                this.isShow = true
            })
        },
        beforeDestroy () {
            this.$eventBus.$off(SHOW_EVALUATION_DIALOG)
        }
    }
</script>

<style lang="scss" scoped>
    .dialog__content {
        text-align: center;
        padding: percent(15, 320) 0;
    }

    .star {
        &__list {
            display: flex;
            justify-content: center;
            padding-top: percent(15, 320);
        }

        &__item {
            font-size: 0;
            width: percent(40, 320);

            &:nth-child(n + 2) {
                margin-left: percent(5, 320);
            }
        }

        &__icon {
            font-size: 30px;
            color: #e3e3e3;

            @at-root .is-active & {
                color: #faba49;
            }
        }

        &__remark {
            color: #faba49;
            font-size: 14px;
            padding-top: percent(10, 320);
        }
    }

    .suggestion {
        padding: percent(15, 320) 0;

        textarea {
            display: block;
            margin: 0 auto;
            border-radius: 4px;
            border: 1px solid #d8d8d8;
            font-size: 14px;
            padding: 5px;
            width: 80%;
            resize: none;
        }
    }
</style>
